import register from '../register.js';
import { getBreakpoint } from './util/breakpoint';

register( 'sticky-station', function() {
  let section         = document.querySelector('.sticky-station');
  let stickyContainer = document.querySelector('.sticky-station__fixed-panel');
  /*eslint-disable */
  let contentSections = document.querySelectorAll(
    '.sticky-station__scroll-content li'
  );
  /*eslint-enable */
  let stickyMedia     = document.querySelector('.sticky-station__media');
  let doc             = document.documentElement;
  let currentIndex    = null;
  let raf             = window.requestAnimationFrame;
  let isActive        = false;
  let isBottom        = false;
  let forEach         = Array.prototype.forEach;
  let winHeight       = window.innerHeight;

  function getScrollTop() {
    return ( window.pageYOffset || doc.scrollTop ) - ( doc.clientTop || 0 );
  }

  function setHeights() {
    let currBreakpoint = getBreakpoint();
    winHeight = window.innerHeight;

    if ( currBreakpoint === 'large' ) {
      // set height of each scroll content <li> equal to window
      forEach.call( contentSections, function( el ) {
        el.style.height = winHeight + 'px';
      });

      // set height of sticky container equal to window
      stickyContainer.style.height = winHeight + 'px';

    } else {
      forEach.call( contentSections, function( el ) {
        el.style.height = 'auto';
      });
      stickyContainer.style.height = 'auto';
    }
  }

  function getPanelIndex() {
    let scrollTop = getScrollTop();
    let sectionOffset = section.offsetTop;
    let fixStart = sectionOffset;
    let fixEnd = fixStart + ( winHeight * ( contentSections.length - 1 ) );

    // how far are we into the scrolling area?
    let percentage = ( scrollTop - fixStart ) / ( fixEnd - fixStart );

    // which panel is visible?
    let panelIndex = 1 + Math.round(
      percentage * ( contentSections.length - 1 )
    );
    // constrain between 1 and contentSections.length
    panelIndex = Math.max( 1, Math.min( contentSections.length, panelIndex ) );

    return panelIndex;
  }

  function checkScroll() {
    let scrollTop = getScrollTop();
    let sectionOffset = section.offsetTop;
    let fixStart = sectionOffset;
    let fixEnd = fixStart +
      ( winHeight * ( contentSections.length - 1 ) ) + 100;

    let index = getPanelIndex();

    if ( currentIndex === null ) {
      currentIndex = index;
    }

    if ( currentIndex !== index ) {
      currentIndex = index;
      // set html dataset to active panel
      stickyMedia.setAttribute( 'data-panel', currentIndex );
    }

    // should the container be fixed yet?
    if ( !isActive && scrollTop >= fixStart && scrollTop <= fixEnd ) {
      stickyMedia.classList.remove('is-bottom');
      stickyContainer.classList.add('is-fixed');
      isActive = true;
    } else if ( isActive && scrollTop < sectionOffset || scrollTop > fixEnd ) {
      stickyContainer.classList.remove('is-fixed');
      isActive = false;
    }

    // should media container be placed at bottom?
    if ( !isActive && !isBottom && scrollTop >= fixEnd ) {
      stickyContainer.classList.add('is-bottom');
      isBottom = true;
    } else if ( isBottom && scrollTop <= fixEnd ) {
      stickyContainer.classList.remove('is-bottom');
      isBottom = false;
    }

    raf( checkScroll );

  }

  // reset heights on window resize
  window.addEventListener( 'resize', setHeights );

  // init
  setHeights();
  checkScroll();

});

export default undefined;
